module.exports = __webpack_public_path__ + "static/img/0005.b112b9fa.png";